/* Shop-Fixes (wird ueber den Cart Drawer auf jeder Seite geladen)
   1. Warenkorb: einheitliche, ruhige Typografie, Zwischensumme etwas groesser
      Schriftstaerke = Grundstaerke des Themes (Inter 300), nicht fetter als der Rest des Shops
   2. Quick-Add-Fenster und Pair With: im selben Stil wie der Warenkorb, Pair With kleiner und ruhiger
   3. "Bag (X)"-Zaehler: aktualisiert sich bei jeder Aenderung im Warenkorb
   4. Gift Box: reduzierter Bereich, Preis erst im aufgeklappten Bereich
      (Texte aus den Theme-Einstellungen werden nur ersetzt, solange sie noch "wrap" enthalten)
   5. Kartentext: wird sofort beim Tippen gespeichert und landet als Bestellnotiz
   6. Groessenfilter: Werte in der Reihenfolge XXS, XS, S, S+, M, L, XL, One size
   7. Gift Card: Auswahl "Physical | Digital" auf beiden Gutschein-Produktseiten
   8. Produktseite mobil: Logo liegt nicht mehr ueber dem Produktbild
*/
(function () {
  var F = 'var(--FONT-STACK-BODY, inherit)';
  var W = 'var(--FONT-WEIGHT-BODY, 300)';
  var FS = '13px';
  var FS_SMALL = '12px';
  var GREY = '#8a8a8a';
  var NOTE_PREFIX = 'Geschenkkarte: ';
  var GIFT_CARD_PHYSICAL = '/products/gift-card';
  var GIFT_CARD_DIGITAL = '/products/zodiaque-digital-gift-card';
  var TXT = 'font-family:' + F + ' !important; font-size:' + FS + ' !important; font-weight:' + W + ' !important; font-style:normal !important; letter-spacing:0 !important; line-height:1.45 !important; color:#000 !important;';
  var TXT_S = 'font-family:' + F + ' !important; font-size:' + FS_SMALL + ' !important; font-weight:' + W + ' !important; font-style:normal !important; letter-spacing:0 !important; line-height:1.4 !important;';

  var css = [
    /* 1. Warenkorb */
    '#cart-drawer .ctm-cart-heading, #cart-drawer .drawer__close,',
    '#cart-drawer .drawer__message, #cart-drawer .free-shipping__default-message, #cart-drawer .free-shipping__success-message,',
    '#cart-drawer .cart__item__title, #cart-drawer .cart__item__title a,',
    '#cart-drawer .cart__price, #cart-drawer .cart__price *,',
    '#cart-drawer .cart__item__selected-options, #cart-drawer .cart__item__selected-options *,',
    '#cart-drawer .qty-label, #cart-drawer .cart__quantity-field, #cart-drawer .cart__item__remove,',
    '#cart-drawer .cart__widget__title,',
    '#cart-drawer .cart__total__label, #cart-drawer .cart__total__price{' + TXT + ' text-transform:none !important;}',
    '#cart-drawer .cart__item__title{margin:0 0 2px !important;}',
    '#cart-drawer .cart__item__selected-options{margin-top:14px !important;}',
    '#cart-drawer .cart__item__remove{text-decoration:underline !important; text-underline-offset:3px; text-decoration-thickness:0.5px; margin-top:14px;}',
    '#cart-drawer summary.cart__widget__title{display:flex !important; align-items:center !important; padding-top:18px !important; padding-bottom:18px !important;}',
    '#cart-drawer .cart__widget__title svg{width:11px !important; height:11px !important; margin-left:auto;}',
    '#cart-drawer .ctm-discount-label{font-family:' + F + ' !important; font-size:12px !important; font-weight:' + W + ' !important; color:#6b6b6b !important; margin:4px 0 16px !important;}',
    /* Zwischensumme groesser */
    '#cart-drawer .ctm-cart-total-wrapper{align-items:baseline !important; margin-top:6px !important;}',
    '#cart-drawer .ctm-cart-total-wrapper .cart__total__label,',
    '#cart-drawer .ctm-cart-total-wrapper .cart__total__price{font-size:16px !important; line-height:1.4 !important;}',
    '#cart-drawer .cart__buttons__fieldset[data-cart-checkout-button] button{',
    '  font-family:' + F + ' !important; font-size:' + FS + ' !important; font-weight:' + W + ' !important; letter-spacing:0.02em !important;',
    '  text-transform:none !important; border-radius:0 !important; padding:17px !important; background:#000 !important; color:#fff !important;}',

    /* 2a. Pair With: kleiner, ruhiger */
    '#cart-drawer .ctm-pair-with-upsell .cart__widget__products{gap:14px !important; padding-bottom:22px;}',
    '#cart-drawer .ctm-pair-with-upsell quick-add-product{width:112px !important; flex:0 0 112px;}',
    '#cart-drawer .ctm-pair-with-upsell .ctm-upsell-products .product-upsell,',
    '#cart-drawer .ctm-pair-with-upsell .product-upsell{border:0 !important; border-radius:0 !important; background:transparent !important; box-shadow:none !important;}',
    '#cart-drawer .ctm-pair-with-upsell .product-upsell__image, #cart-drawer .ctm-pair-with-upsell .product-upsell__image img,',
    '#cart-drawer .ctm-pair-with-upsell .product-upsell__image__thumb{border-radius:0 !important;}',
    '#cart-drawer .ctm-pair-with-upsell .product-upsell__content{padding:8px 0 0 !important; position:relative;}',
    '#cart-drawer .ctm-upsell-products .product-upsell__title, #cart-drawer .ctm-upsell-products .product-upsell__title a{' + TXT_S + ' color:#000 !important; text-transform:none !important;',
    '  min-height:0 !important; margin:0 0 2px !important; display:-webkit-box !important; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;}',
    '#cart-drawer .ctm-upsell-products .product-upsell__price, #cart-drawer .ctm-upsell-products .product-upsell__price *{' + TXT_S + ' color:' + GREY + ' !important; margin:0 !important;}',
    '#cart-drawer .ctm-pair-with-upsell .product-upsell__content .btn__outer{justify-content:flex-start !important; margin-top:6px;}',
    '#cart-drawer .drawer__foot .cart__widget__content__inner .ctm-upsell-btn{',
    '  width:auto !important; height:auto !important; min-width:0 !important; min-height:0 !important; padding:0 !important;',
    '  border:0 !important; border-radius:0 !important; background:transparent !important; color:#000 !important;',
    '  font-family:' + F + ' !important; font-size:0 !important; line-height:1.4 !important;}',
    '#cart-drawer .drawer__foot .cart__widget__content__inner .ctm-upsell-btn > *{display:none !important;}',
    '#cart-drawer .drawer__foot .cart__widget__content__inner .ctm-upsell-btn::after{content:"Add"; font-size:' + FS_SMALL + '; font-weight:' + W + ';',
    '  text-decoration:underline; text-underline-offset:3px; text-decoration-thickness:0.5px;}',
    '#cart-drawer .drawer__foot .cart__widget__content__inner .ctm-upsell-btn:hover{background:transparent !important; color:' + GREY + ' !important;}',
    '#cart-drawer .drawer__foot .cart__widget__content__inner .ctm-upsell-btn.is-added{background:transparent !important; color:' + GREY + ' !important;}',
    '#cart-drawer .drawer__foot .cart__widget__content__inner .ctm-upsell-btn.is-added::after{content:"Added"; text-decoration:none;}',

    /* 4. Gift Box Bereich */
    '#cart-drawer .ctm-summary-price{display:none !important;}',
    '#cart-drawer .ctm-gift-wrapper{padding-top:0 !important;}',
    '#cart-drawer .ctm-gift-wrapper .gift-row{align-items:flex-start !important; gap:14px !important; margin-bottom:22px !important;}',
    '#cart-drawer .ctm-gift-wrapper .gift-icon{max-width:56px !important; flex:0 0 56px;}',
    '#cart-drawer .ctm-gift-wrapper .gift-icon img{opacity:1 !important; border-radius:0 !important;}',
    '#cart-drawer .ctm-gift-wrapper .gift-content{flex:1;}',
    '#cart-drawer .ctm-gift-wrapper .gift-text{' + TXT + ' color:#6b6b6b !important; margin:0 0 12px !important;}',
    '#cart-drawer .ctm-gift-wrapper .gift-toggle{display:flex !important; align-items:center !important; gap:10px !important; width:100%;}',
    '#cart-drawer .ctm-gift-wrapper .ctm-gift-wrap-checkbox{' + TXT + ' text-transform:none !important;}',
    '#cart-drawer .ctm-gift-wrapper .ctm-gift-price{margin-left:auto; ' + TXT + '}',
    '#cart-drawer .ctm-gift-wrapper .gift-wrap-option{display:none !important;}',
    '#cart-drawer .ctm-gift-wrapper input[type="checkbox"]{-webkit-appearance:none; appearance:none; width:14px; height:14px;',
    '  margin:0; border:0.5px solid #000; border-radius:0; background:#fff; cursor:pointer; flex:0 0 14px;}',
    '#cart-drawer .ctm-gift-wrapper input[type="checkbox"]:checked{background:#000; box-shadow:inset 0 0 0 2px #fff;}',
    '#cart-drawer .ctm-gift-wrapper .gift-inner{margin-top:16px !important;}',
    '#cart-drawer .ctm-gift-wrapper .ctm-gift-wrap-note{display:block; font-family:' + F + ' !important; font-size:12px !important; font-weight:' + W + ' !important; letter-spacing:0 !important;',
    '  text-transform:none !important; color:#6b6b6b !important; margin-bottom:8px !important;}',
    '#cart-drawer .ctm-gift-wrapper .gift-message textarea{' + TXT + ' min-height:72px !important; padding:10px 12px !important;',
    '  border:0.5px solid #d6d3ce !important; border-radius:0 !important; background:#fff !important; resize:vertical;}',
    '#cart-drawer .ctm-gift-wrapper .gift-message textarea::placeholder{font-family:' + F + ' !important; font-size:' + FS + ' !important; color:#a8a8a8 !important; font-style:normal !important;}',
    '#cart-drawer .ctm-gift-wrapper .price{font-family:' + F + ' !important;}',

    /* 2b. Quick-Add-Fenster */
    '.ctm-quick-add-model .product-quick-add__form{padding:32px 24px 36px !important;}',
    '.ctm-quick-add-model .product__title, .ctm-quick-add-model .product__title a{' + TXT + ' text-transform:none !important;}',
    '.ctm-quick-add-model .product__block.product__head{margin-bottom:4px !important; padding-right:40px;}',
    '.ctm-quick-add-model .product__price, .ctm-quick-add-model .product__price *{' + TXT + '}',
    '.ctm-product-quick-add .radio__fieldset .radio__legend__option-name{' + TXT + ' text-transform:none !important; color:#6b6b6b !important; margin-bottom:10px !important;}',
    '.ctm-quick-add-model .product__form__holder{padding-top:20px !important;}',
    '.ctm-product-quick-add .radio__fieldset .radio__button label,',
    '.ctm-product-quick-add .ctm-variant-options label{' + TXT + ' min-width:48px; height:40px; padding:0 14px !important;',
    '  border:0.5px solid #d6d3ce !important; border-radius:0 !important; background:#fff !important;',
    '  display:flex; align-items:center; justify-content:center; transition:border-color .2s, background .2s, color .2s;}',
    '.ctm-product-quick-add .radio__fieldset .radio__button label:hover{border-color:#000 !important;}',
    '.ctm-product-quick-add .radio__fieldset .radio__button input:checked~label{background:#000 !important; color:#fff !important; border-color:#000 !important;}',
    '.ctm-product-quick-add .product__submit__item button[data-add-to-cart]{',
    '  font-family:' + F + ' !important; background:#000 !important; color:#fff !important; border:0 !important; border-radius:0 !important;',
    '  font-size:' + FS + ' !important; font-weight:' + W + ' !important; letter-spacing:0.02em !important; text-transform:none !important; padding:17px !important; margin-top:24px;}',
    '.ctm-product-quick-add .product__submit__item button[data-add-to-cart]:disabled,',
    '.ctm-product-quick-add .product__submit__item button[data-add-to-cart][disabled]{background:#000 !important; color:#fff !important; opacity:0.35 !important;}',
    '.ctm-product-quick-add .product-quick-add__close{width:32px !important; height:32px !important;}',
    '.ctm-product-quick-add .product-quick-add__close svg{width:14px; height:14px; stroke-width:1;}',
    '.ctm-product-quick-add .product-quick-add__content{border-radius:0 !important;}',

    /* 7. Gift Card Auswahl */
    '.ctm-format-switch{margin:18px 0 6px;}',
    '.ctm-format-switch__label{font-family:' + F + '; font-size:' + FS + '; font-weight:' + W + '; color:#6b6b6b; margin:0 0 10px;}',
    '.ctm-format-switch__options{display:flex; gap:8px;}',
    '.ctm-format-switch__option{font-family:' + F + '; font-size:' + FS + '; font-weight:' + W + '; letter-spacing:0;',
    '  display:flex; align-items:center; justify-content:center; min-width:96px; height:40px; padding:0 16px;',
    '  border:0.5px solid #d6d3ce; border-radius:0; background:#fff; color:#000; text-decoration:none; transition:border-color .2s;}',
    'a.ctm-format-switch__option:hover{border-color:#000;}',
    '.ctm-format-switch__option.is-active{background:#000; color:#fff; border-color:#000; cursor:default;}',

    /* 8. Produktseite mobil: Bild beginnt unter dem Header statt dahinter */
    '@media (max-width:750px){',
    '  body.template-product .index-product.section-padding{padding-top:0 !important;}',
    '  body.template-product .custom-product-wrapper .product__page .product__images{margin-top:0 !important;}',
    '}'
  ].join('\n');

  var style = document.createElement('style');
  style.id = 'ctm-cart-fixes';
  style.textContent = css;
  document.head.appendChild(style);

  function cleanTotals() {
    document.querySelectorAll('#cart-drawer .cart__total__price').forEach(function (el) {
      if (/\s[A-Z]{3}\s*$/.test(el.textContent)) el.textContent = el.textContent.replace(/\s[A-Z]{3}\s*$/, '').trim();
    });
  }

  function hasWrap(el) { return el && /wrap/i.test(el.textContent); }

  function updateGiftTexts() {
    document.querySelectorAll('.ctm-gift-wrapper').forEach(function (wrapper) {
      var priceEl = wrapper.querySelector('.gift-wrap-option .price');
      var price = priceEl ? priceEl.textContent.replace('+', '').trim() : '';

      var details = wrapper.closest('details');
      var summary = details ? details.querySelector('summary') : null;
      if (summary) {
        var textNode = null;
        summary.childNodes.forEach(function (n) {
          if (!textNode && n.nodeType === 3 && n.textContent.trim() !== '') textNode = n;
        });
        if (textNode) {
          if (textNode.textContent.trim() !== 'Gift Box') textNode.textContent = 'Gift Box';
        } else {
          summary.insertBefore(document.createTextNode('Gift Box'), summary.firstChild);
        }
        var oldPs = summary.querySelector('.ctm-summary-price');
        if (oldPs) oldPs.parentNode.removeChild(oldPs);
      }

      var intro = wrapper.querySelector('.gift-text');
      if (hasWrap(intro) || (intro && /gift box/i.test(intro.textContent) && !/presented/i.test(intro.textContent))) {
        intro.textContent = 'Presented in our signature Zodiaque gift box, with a handwritten card if you wish.';
      }
      var toggle = wrapper.querySelector('.ctm-gift-wrap-checkbox');
      if (toggle && (hasWrap(toggle) || /^yes/i.test(toggle.textContent.trim()))) toggle.textContent = 'Add gift box';

      var toggleRow = wrapper.querySelector('.gift-toggle');
      if (toggleRow && price) {
        var gp = toggleRow.querySelector('.ctm-gift-price');
        if (!gp) {
          gp = document.createElement('span');
          gp.className = 'ctm-gift-price';
          toggleRow.appendChild(gp);
        }
        if (gp.textContent !== price) gp.textContent = price;
      }

      var note = wrapper.querySelector('.ctm-gift-wrap-note');
      if (note && /^your message$/i.test(note.textContent.trim())) note.textContent = 'Card message (optional)';
      var ta = wrapper.querySelector('#gift-note');
      if (ta && /beautiful/i.test(ta.getAttribute('placeholder') || '')) ta.setAttribute('placeholder', 'Your message');
    });
  }

  var noteTimer;
  function saveGiftNote(textarea, keepalive) {
    var match = /attributes\[(.+)\]/.exec(textarea.name || '');
    var attrName = match ? match[1] : 'Gift note';
    var value = textarea.value.trim();
    var attrs = {};
    attrs[attrName] = value;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: !!keepalive,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs, note: value ? NOTE_PREFIX + value : '' })
    }).catch(function () {});
  }

  function bindGiftNote() {
    document.addEventListener('input', function (e) {
      if (e.target && e.target.id === 'gift-note') {
        clearTimeout(noteTimer);
        var t = e.target;
        noteTimer = setTimeout(function () { saveGiftNote(t); }, 500);
      }
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.id === 'gift-note') saveGiftNote(e.target);
    });
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('button[name="checkout"], .cart__checkout');
      var ta = document.getElementById('gift-note');
      if (btn && ta && ta.value.trim() !== '') {
        clearTimeout(noteTimer);
        saveGiftNote(ta, true);
      }
    }, true);
  }

  var SIZE_RANK = { 'XXS': 0, 'XS': 1, 'S': 2, 'S+': 3, 'M': 4, 'L': 5, 'XL': 6, 'XXL': 7 };
  function sizeRank(li) {
    var text = li.textContent.replace(/\s+/g, ' ').trim();
    var m = /\((XXS|XS|S\+|S|M|L|XL|XXL)\)/.exec(text);
    if (m) return SIZE_RANK[m[1]];
    var plain = text.replace(/\s*\(\d+\)\s*$/, '').trim().toUpperCase();
    if (SIZE_RANK.hasOwnProperty(plain)) return SIZE_RANK[plain];
    if (/one size/i.test(text)) return 8;
    return null;
  }
  function sortSizeFilters() {
    document.querySelectorAll('.collection__sidebar ul, collection-filters-form ul, .filter-group ul').forEach(function (ul) {
      var items = Array.prototype.filter.call(ul.children, function (el) { return el.tagName === 'LI'; });
      if (items.length < 3) return;
      var ranked = items.map(function (li, i) { return { li: li, rank: sizeRank(li), i: i }; });
      var matched = ranked.filter(function (r) { return r.rank !== null; });
      if (matched.length < 3 || matched.length < items.length - 1) return;
      var sorted = ranked.slice().sort(function (a, b) {
        var ra = a.rank === null ? 99 : a.rank;
        var rb = b.rank === null ? 99 : b.rank;
        return ra - rb || a.i - b.i;
      });
      var changed = sorted.some(function (r, idx) { return r.li !== items[idx]; });
      if (changed) sorted.forEach(function (r) { ul.appendChild(r.li); });
    });
  }

  function addGiftCardSwitch() {
    var path = window.location.pathname.replace(/\/$/, '');
    var isPhysical = path.slice(-GIFT_CARD_PHYSICAL.length) === GIFT_CARD_PHYSICAL;
    var isDigital = path.slice(-GIFT_CARD_DIGITAL.length) === GIFT_CARD_DIGITAL;
    if (!isPhysical && !isDigital) return;
    if (document.querySelector('.ctm-format-switch')) return;

    var prefix = path.slice(0, path.length - (isPhysical ? GIFT_CARD_PHYSICAL.length : GIFT_CARD_DIGITAL.length));
    var wrap = document.createElement('div');
    wrap.className = 'product__block ctm-format-switch';
    wrap.innerHTML =
      '<p class="ctm-format-switch__label">Format</p>' +
      '<div class="ctm-format-switch__options">' +
        (isPhysical
          ? '<span class="ctm-format-switch__option is-active" aria-current="true">Physical</span>'
          : '<a class="ctm-format-switch__option" href="' + prefix + GIFT_CARD_PHYSICAL + '">Physical</a>') +
        (isDigital
          ? '<span class="ctm-format-switch__option is-active" aria-current="true">Digital</span>'
          : '<a class="ctm-format-switch__option" href="' + prefix + GIFT_CARD_DIGITAL + '">Digital</a>') +
      '</div>';

    var price = document.querySelector('main .product__price, #MainContent .product__price, .product__price');
    var anchor = price ? (price.closest('.product__block') || price) : document.querySelector('h1');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  }

  function setDrawerCount(count) {
    document.querySelectorAll('.ctm-cart-heading').forEach(function (heading) {
      var label = heading.getAttribute('data-label');
      if (!label) {
        label = heading.textContent.replace(/\s*\(\s*\d*\s*\)\s*$/, '').trim();
        heading.setAttribute('data-label', label);
      }
      var text = label + ' (' + count + ')';
      if (heading.textContent !== text) heading.textContent = text;
    });
    var headerIcon = document.querySelector('.header__cart__status[data-cart-count]');
    if (headerIcon) {
      var current = headerIcon.getAttribute('data-cart-count');
      if (current === 'undefined' || current === null || current === '') headerIcon.setAttribute('data-cart-count', count);
    }
  }

  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      updateGiftTexts();
      cleanTotals();
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) { setDrawerCount(cart.item_count); })
        .catch(function () {});
    }, 150);
  }

  var filterTimer;
  function init() {
    updateGiftTexts();
    cleanTotals();
    bindGiftNote();
    sortSizeFilters();
    addGiftCardSwitch();

    document.addEventListener('theme:cart:change', refresh);
    document.addEventListener('theme:cart:refresh', refresh);

    var headerIcon = document.querySelector('.header__cart__status');
    if (headerIcon) new MutationObserver(refresh).observe(headerIcon, { attributes: true, attributeFilter: ['data-cart-count'] });

    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      new MutationObserver(function (muts) {
        var relevant = muts.some(function (m) {
          var t = m.target;
          return !(t.classList && (t.classList.contains('ctm-gift-price') || t.classList.contains('cart__total__price') || t.classList.contains('ctm-cart-heading')));
        });
        if (relevant) refresh();
      }).observe(drawer, { childList: true, subtree: true });
    }

    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (main) {
      new MutationObserver(function () {
        clearTimeout(filterTimer);
        filterTimer = setTimeout(sortSizeFilters, 200);
      }).observe(main, { childList: true, subtree: true });
    }
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
